import React from 'react';
import { useAppState } from '../contexts/AppStateContext';
import PdfToImageTool from './tools/PdfToImageTool';
import PdfCompressTool from './tools/PdfCompressTool';
import ImageConvertTool from './tools/ImageConvertTool';
import ImageResizeTool from './tools/ImageResizeTool';
import ImageCompressTool from './tools/ImageCompressTool';

const Workspace = () => {
  const { state } = useAppState();

  const renderTool = () => {
    switch (state.currentTool) {
      case 'pdf-to-image':
        return <PdfToImageTool />;
      case 'pdf-compress':
        return <PdfCompressTool />;
      case 'image-convert':
        return <ImageConvertTool />;
      case 'image-resize':
        return <ImageResizeTool />;
      case 'image-compress':
        return <ImageCompressTool />;
      default:
        return <PdfToImageTool />;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
      {renderTool()}
    </div>
  );
};

export default Workspace;